<template lang="pug">
.video-library-search
    form.video-library-search__inline.video-library-search__inline--search(@submit.prevent.stop="() => false")
        i.fas.fa-search.js-video-search
        input.video-library-search__input.video-library-search__input--search(
            @keypress.enter.prevent="executeSearch()",
            v-model="queryModel",
            :placeholder="options.queryPlaceholderText",
            :autocomplete="autocomplete",
            type="text",
            name="search-query")
        button.video-library-search__clear.btn(v-if="queryModel.length" @click.prevent="clearSearch()" @keypress.enter.prevent="clearSearch()") Clear
    //- this should probably be its own component...
    button.video-library-search__inline.video-library-search__inline--filters(ref="filter" @click.prevent="positionFilters()" @keypress.escape.prevent.stop="positionFilters()")
        i.fas.fa-filter(ref="filtersAnchor")
        .video-library-search__input.video-library-search__input--filters(type="text" name="filters" id="filters" ref="filtersInput")
            template(v-if="activeFilters && Object.keys(activeFilters).length")
                span.video-library-search__tag(v-for="category in activeFilters.categories") {{getCategoryName(category)}}
                span.video-library-search__tag(v-for="level in activeFilters.levels") {{getLevelName(level)}}
                span.video-library-search__tag(v-for="type in activeFilters.types") {{type}}
            span(v-else) Filter Videos

    form.video-library-filters(action="#" ref="filters" @submit.prevent.stop="submitFilters()")
        span.video-library-filters__arrow(ref="filtersArrow")
        fieldset.video-library-filters__fieldset(name="levels")
            legend.video-library-filters__legend Level
            .video-library-filters__inline(v-for="level in levels" :key="level.value")
                input.video-library-filters__checkbox(type="checkbox" :id="level.name" :name="`level-${level.name}`" :value="level.value")
                label.video-library-filters__label(:for="level.name") {{ level.name }}
        // The filters feature expects that the value of video-library-filters__checkbox matches the data-filters from video-library-search-content__item
        fieldset.video-library-filters__fieldset.video-library-filters__fieldset--large(name="categories")
            legend.video-library-filters__legend Categories
            .video-library-filters__inline(v-for="category in categories" :key="category.id")
                input.video-library-filters__checkbox(type="checkbox" :id="category.id" :name="`category-${category.name}`" :value="category.id")
                label.video-library-filters__label(:for="category.id") {{ category.name }}

        fieldset.video-library-filters__fieldset(name="types")
            legend.video-library-filters__legend Type
            .video-library-filters__inline(v-for="val in types" :key="val")
                input.video-library-filters__checkbox(type="checkbox" :id="val" :name="`type-${val}`" :value="val")
                label.video-library-filters__label(:for="val") {{ val }}
        .video-library-filters__controls
            input.video-library-filters__reset(type="reset" value="Clear all filters" ref="filtersReset"  @click.prevent="resetFilters()" @keypress.enter.prevent="resetFilters()")
            button.video-library-filters__cancel(ref="filtersCancel" @click.prevent="closeFilters()" @keypress.enter.prevent="closeFilters()") Cancel
            input.video-library-filters__submit(type="Submit" value="Apply")
</template>
    
<script>
    import processTemplate from 'string-template';
    import {
        computePosition,
        offset,
        shift,
        arrow
    } from '@floating-ui/dom';
    export default {
        name: "VideoLibraryQuery",
        components: {},
        data() {
            // We're using sets so that theoretically new values can be grabbed from the item results and added to the filters
            return {
                categoriesEndpoint: null,
                classNames : {
                    active: 'is-active',
                    hidden: 'is-hidden',
                    filtered: 'is-filtered'
                },
                levels: new Set([
                    {
                        name: "Beginner",
                        value: "0"
                    },
                    {
                        name: "Intermediate",
                        value: "1"
                    },
                    {
                        name: "Advanced",
                        value: "2"
                    }
                ]),
                categories: [
                    { name: 'Introduction to Options', id:'ef92da69-a0c8-4bdf-b7dc-d0faf2fb95e0'},
                    { name: 'Options Core Concepts - Level 1', id:'ef92da69-a0c8-4def-b73c-d0faf2fb95e0'},
                    { name: 'Options Core Concepts - Level 2', id:'ef92da69-a0d8-4bef-b73c-d0faf2fb95e0'},
                    { name: 'Outright Positions and Simple Spreads', id:'ef92dd69-a0c8-4bef-b73c-d0faf2fb95e0'},
                    { name: 'Strategy Development and Position Management', id:'ef92da69-a0c8-4bef-b73c-d0fafdfb95e0'},
                    { name: 'Strategies For Potential Income Generation', id:'ef92da69-a0c8-4bef-b7dc-d0faf2fb95e0'},
                    { name: 'Advanced Positions', id:'ef9dda69-a0c8-4bef-b73c-d0faf2fb95e0'}
                ],
                types: new Set(['Short Video', 'Webinar']),
                activeFilters: null
            };
        },
        computed: {
            autocomplete() {
                const autocomplete = this.options.queryAllowAutocomplete;
                return autocomplete === true ?
                    'on' : 
                    autocomplete === false ? 
                        'off' : 
                        typeof autocomplete === 'string' && autocomplete.trim().length ?
                            autocomplete.trim() :
                            false;
            },
            currentResultsStart() {
                let totalResults = this.results.totalResultCount;
                if (this.results.currentPage == 0 || this.options.preserveResults) {
                    if (totalResults) return 1;
                    return 0;
                }
                return this.results.currentPage * this.results.pageSize + 1;
            },
            currentResultsEnd() {
                let totalResults = this.results.totalResultCount;
                let currentPage = this.results.currentPage;
                let pageSize = this.results.pageSize;
                let max = (currentPage + 1) * pageSize;
    
                if (currentPage == 0) {
                    if (totalResults <= pageSize) {
                        return totalResults;
                    }
                    return pageSize;
                } else {
                    if (max > totalResults) return totalResults;
                    return max;
                }
            },
            label() {
                return processTemplate(this.options.resultsLabelTemplate, {
                    start: this.currentResultsStart,
                    end: this.currentResultsEnd,
                    total: this.results.totalResultCount,
                });
            },
            results() {
                return this.$store.getters.results;
            },
            sort() {
                return this.$store.getters.sort;
            },
            sortModel: {
                get() {
                    return this.sort;
                },
                set(val) {
                    this.setSort(val);
                },
            },
            query() {
                return this.$store.getters.query;
            },
            queryModel: {
                get() {
                    return this.query;
                },
                set(val) {
                    this.setQuery(val);
                },
            },
            extended() {
                return this.$store.getters.extended;
            },
        },
        methods: {
            getCategoryName (id) {
                if (!this.categories)
                    return null;
                const category = this.categories.find(cat => cat.id === id);
                return category ? category.name : null;
            },
            getLevelName (val) {
                if (!this.levels)
                    return null;
                for (let lvl of this.levels) {
                    if(lvl.value === val) return lvl.name;
                } 
                return null;
            },
            clearPreviousItemResults() {
                this.$store.commit("clearPreviousItemResults");
                this.$store.commit("setPageIndex", 0);
            },
            setSort(val) {
                let value;
                if (typeof val === "object" && val.hasOwnProperty("target"))
                    value = val.target.value;
                else value = val;
                this.$store.dispatch("changeSort", value);
            },
            setQuery(val) {
                let value;
                if (typeof val === "object") value = val.target.value;
                else value = val;
                this.$store.commit("setQuery", value);
            },
            resetSearch(callback) {
                this.$store.dispatch("resetSearch", callback);
            },
            extend(callback) {
                this.$store.commit("extend", callback);
            },
            clearSearch() {
                this.setQuery("");
                this.executeSearch();
            },
            executeSearch(callback) {
                this.checkActiveFilters()
                this.$emit('setSearchSubmitted', !!this.query);
                this.$el.querySelector('.video-library-search__input').blur();
                if (this.options.preserveResults) this.$store.commit("clearPreviousItemResults");
                return this.$store.dispatch("executeSearch", callback);
            },
            // non-bluesearch
            closeFilters() {
                // filters.classList.toggle(classNames.active)
                this.$refs.filters.classList.toggle(this.classNames.active)
                // console.log(this.classNames)
            },
            resetFilters() {
                this.$refs.filters.reset();
                this.submitFilters();
            },
            positionFilters() {
                this.closeFilters()
                computePosition(this.$refs.filtersAnchor, this.$refs.filters, {
                    placement: 'bottom',
                    middleware: [
                        offset(35),
                        // flip(),
                        shift({
                            padding: 5
                        }),
                        arrow({
                            element: this.$refs.filtersArrow
                        })
                    ]
                }).then(({
                    x,
                    y,
                    placement,
                    middlewareData
                }) => {
                    Object.assign(this.$refs.filters.style, {
                        left: `${x}px`,
                        top: `${y}px`,
                    });
                    const {
                        x: arrowX,
                        y: arrowY
                    } = middlewareData.arrow;
                    const staticSide = {
                        top: 'bottom',
                        right: 'left',
                        bottom: 'top',
                        left: 'right',
                    } [placement.split('-')[0]];

                    Object.assign(this.$refs.filtersArrow.style, {
                        left: arrowX != null ? `${arrowX}px` : '',
                        top: arrowY != null ? `${arrowY}px` : '',
                        right: '',
                        bottom: '',
                        [staticSide]: '-15px',
                    });
                });
            },
            generateObj(obj,key) {
                return Object.keys(obj).filter(k => k.includes(key)).map(k => obj[k])
            },
            checkScroll() {
                const rect = this.$el.getBoundingClientRect();
                const scrollTop = document.body.scrollTop;
                const targetTop = rect.top + scrollTop;

                if (targetTop < scrollTop) {
                    document.body.scrollTo({ top: targetTop - 20, behavior: "smooth" });
                }
            },
            submitFilters() {
                this.closeFilters()
                this.checkScroll()
                this.executeSearch()
            },
            checkActiveFilters() {
                const data = new FormData(this.$refs.filters)
                const dataObj = Object.fromEntries(data.entries())
                // console.log(dataObj)
                // filter key includes category remove prefix category-
                const categoryFilters = this.generateObj(dataObj, 'category')
                const levelFilters = this.generateObj(dataObj, 'level')
                const typeFilters = this.generateObj(dataObj, 'type')
                this.extend(extended => {
                    if (!Object.keys(dataObj).length)
                        return {};
                    extended === null ? extended = {} : null;
                    extended.categories = categoryFilters.length ? [...categoryFilters] : undefined;
                    extended.levels = levelFilters.length ? [...levelFilters] : undefined;
                    extended.types = typeFilters.length ? [...typeFilters] : undefined;
                    return extended
                });
                this.activeFilters = this.extended
                this.$emit('setActiveFilters', this.transformActiveFilters(this.extended))
                Object.keys(dataObj).length > 0 ? this.$emit('setHasFilters', true) : this.$emit('setHasFilters', false)
            },
            transformActiveFilters(filters) {
                const ref = this;
                return {
                    types: filters.types,
                    levels: filters.levels,
                    categories: filters.categories && filters.categories.map((val, idx) => {
                        return ref.getCategoryName(val)
                    })
                };
            },
            fetchCategories() {
                fetch(this.categoriesEndpoint)
                .then(response => {
                    if (!response.ok) {
                    throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    this.categories = data;
                    // console.log(this.categories);
                })
                .catch(error => console.error(error));
            },
            setSearchSubmitted() {
                this.$emit('setSearchSubmitted', true)
            }
        },
        created() { 
            const location = window.location;
            this.categoriesEndpoint = `${location.origin}${this.options.categoryEndpoint}`;
        },
        mounted() { 
            // resetting the set on mounted
            this.types = new Set();
            // loop through this.$store.getters.results.itemResults.meta getting all type values and pushing to this.types
            this.results.itemResults.forEach(item => {
                this.types.add(item.meta.type);
            });
            // console.log(this.$store.getters.results)
            this.fetchCategories();

						const filtersButton = this.$el.querySelector("button.video-library-search__inline");
						const filtersFormSubmit = this.$el.querySelector("input.video-library-filters__submit");

						const closeFiltersDropdown = e => {
							if (this.$el.querySelector("form.video-library-filters.is-active")) this.closeFilters();
						}

						document.body.addEventListener('click', (e) => {
							if (e.target.matches(".video-library-filters") || !!e.target.closest(".video-library-filters") || e.target.matches("button.video-library-search__inline") || !!e.target.closest("button.video-library-search__inline")) return;
							closeFiltersDropdown();
						});
						document.body.addEventListener('keydown', (e) => {
							if (e.key === "Escape") closeFiltersDropdown();
						});
						filtersButton.addEventListener('keydown', (e) => {
							if (e.key === "Tab" && e.shiftKey) closeFiltersDropdown();
						});
						filtersFormSubmit.addEventListener('keydown', (e) => {
							if (e.key === "Tab" && !e.shiftKey) closeFiltersDropdown();
						});
        },
    };
</script>
    
<style lang="scss" scoped>
    span.root {
        display: contents;
    }
    
    .search-query {
        display: flex;
        flex-direction: column;
        padding: 0;
        margin: 0;
        flex: 1 1 100%;
        gap: 0.5rem;
    
        @include mq(sm) {
            gap: 0;
        }
    
        &__form {
            display: flex;
            flex-direction: column;
            position: relative;
            flex: 1 1 100%;
            padding: 0;
            margin: 0;
            gap: 0.5rem;
    
            @include mq(sm) {
                gap: 0;
                flex-direction: row;
            }
        }
    
        &__wrapper {
            display: flex;
            width: 100%;
            border: 1px solid var(--border-color);
    
            &:focus-within {
                box-shadow: inset 0 0 0 0.125rem var(--focus-color);
            }
    
            @include mq(sm) {
                flex: 1 1 100%;
            }
        }
    
        &__label,
        &__sort-label {
            @include hideVisually;
        }
    
        &__input {
            @include clean(input);
            width: 100%;
            margin: 0;
            padding: 1rem;
    
            @include mq(sm) {
                flex: 1 1 100%;
            }
    
            &:focus {
                box-shadow: none !important;
            }
    
            &::placeholder {
                color: var(--color);
                font-weight: 300;
            }
        }
    
        &__reset {
            align-self: center;
            flex: 0 0 auto;
            appearance: none;
            border: none;
            background: none;
            border-radius: 0;
            cursor: pointer;
            padding: 0.5rem;
            margin: 0 0.5rem;
            font-weight: 700;
            color: var(--reset-color);
            transition: var(--reset-transition);
    
            &:hover {
                color: var(--reset-hover-color);
            }
        }
    
        &__submit {
            @include clean(button);
            flex: 0 0 auto;
            padding: 1rem;
            background: var(--button-background);
            color: var(--button-color);
            transition: var(--button-transition);
    
            @include mqdn(sm) {
                order: 4;
            }
    
            &:hover {
                background: var(--button-hover-background);
                color: var(--button-hover-color);
            }
        }
    
        &__sort {
            position: relative;
            flex: 0 0 auto;
            margin: 0;
            border: 1px solid var(--border-color);
            display: flex;
            align-items: center;
    
            @include mq(sm) {
                margin-left: 1rem;
            }
    
            &::after {
                content: "";
                position: absolute;
                top: 50%;
                right: 1.25rem;
                height: 0.5rem;
                width: 0.5rem;
                border-left: 2px solid;
                border-bottom: 2px solid;
                transform: translate(50%, -75%) rotate(-45deg);
            }
    
            select {
                @include clean(input);
                padding: 1rem;
                padding-right: 2.5rem;
                min-width: 100%;
            }
        }
    
        &__results {
            line-height: 1;
            padding: 0.25rem 0.5rem;
            font-size: 0.75rem;
            align-self: flex-start;
            background: var(--label-background);
            color: var(--label-color);
        }
    }
    </style>